import { render } from "./SurveyLocaleList.vue?vue&type=template&id=79188d94"
import script from "./SurveyLocaleList.vue?vue&type=script&lang=js"
export * from "./SurveyLocaleList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__